var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSimMff2 = function SvgSimMff2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 21 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#F76808",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M4.36 5.01h13.13v13.807H3.683V5.686zm10.83-2.612v2.24m-.004-2.234v2.24m0-2.24v2.24m-4.603-2.24v2.24m-4.602-2.24v2.24M3.683 19.1v2.24M17.49 19.1v2.24m-.002-2.234v2.24m0-2.24v2.24m-4.603-2.24v2.24m-4.604-2.24v2.24"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M20.174 1H1v22.613h19.174z"
  })));
};
export default SvgSimMff2;